/** Sectores nuevos — se fusiona con industries.ts (deep merge). */
export default {
  industries: {
    grocery: {
      name: 'Supermercados y alimentación',
      tagline: 'Pensado para alimentación',
      headline: 'Entrega por franjas y rutas densas para',
      headlineHighlight: 'retail fresco',
      description:
        'Mismo día y entrega programada con franjas horarias, flujos de sustitución y rutas IA para alta densidad de paradas, sin perder disciplina de cadena de frío.',
      heroKeyPoints: [
        'Ventanas de entrega y capacidad de franja fiables',
        'La IA agrupa pedidos por zona para menos km por entrega',
        'Seguimiento de marca con ETA en vivo por cesta',
        'Secuenciación técnica para líneas refrigeradas y congeladas',
      ],
      stats: [
        { value: '35%', label: 'Más entregas por ruta' },
        { value: '96%', label: 'Franjas a tiempo' },
        { value: '50%', label: 'Menos consultas WISMO' },
      ],
      painPoints: [
        { title: 'Las franjas fallan con el volumen', description: 'Los picos saturan rutas fijas: el cliente pierde la ventana y se va a la competencia.' },
        { title: 'Las sustituciones rompen la confianza', description: 'Sin comunicación clara, los cambios por rotura generan devoluciones y malas reseñas.' },
        { title: 'Cadena de frío en última milla', description: 'Ambiente, refrigerado y congelado en una misma ruta exigen secuencia, no intuición.' },
      ],
      features: [
        { title: 'Motor de franjas y capacidad', description: 'Ventanas reservables según flota, tiempos de ruta y cortes de preparación.', tag: 'IA' },
        { title: 'Rutas con prioridad de densidad', description: 'Optimiza paradas por hora y puntualidad de franja, no solo distancia.', tag: 'IA' },
        { title: 'Mensajería de sustituciones', description: 'Avisa al cliente antes de que salga el repartidor con aprobar/rechazar claro.' },
        { title: 'Seguimiento en vivo de marca', description: 'Tracking de tienda con ETA cada vez más precisa e instrucciones de entrega.' },
        { title: 'Secuenciación por temperatura', description: 'Ordena paradas para minimizar tiempo fuera de vehículo en frío.' },
        { title: 'App conductor y POD', description: 'Escaneo en recogida, foto en puerta, control de edad donde aplique.' },
        { title: 'Analítica de operaciones', description: 'Ocupación de franja, coste por entrega y mapas de excepción por tienda y franja horaria.' },
        { title: 'Sincro POS y OMS', description: 'Conecta e-commerce, OMS y tienda en un plan vivo.' },
      ],
      useCases: [
        'Supermercado mismo día',
        'Hipermercado con franjas',
        'Dark store / quick commerce',
        'Cadenas regionales',
        'Recorridos tipo meal kit',
        'Furgonetas de reposición B2B a tienda',
      ],
    },
    'b2b-distribution': {
      name: 'Distribución B2B y mayorista',
      tagline: 'Pensado para distribución',
      headline: 'Software de entrega para',
      headlineHighlight: 'del CD al cliente',
      description:
        'Rutas multistop desde el centro a comercios y obras con prueba de entrega, ventanas en muelle y analítica para operaciones y finanzas, sin hojas de cálculo.',
      heroKeyPoints: [
        'Rutas multistop con pallets y SKU',
        'POD digital con firma, foto y marca de tiempo',
        'Visibilidad tipo expedidor para cuentas clave',
        'Informes de coste por entrega y coste de servicio',
      ],
      stats: [
        { value: '22%', label: 'Menor coste por entrega' },
        { value: '99%', label: 'Captura de POD' },
        { value: '2×', label: 'Paradas por turno' },
      ],
      painPoints: [
        { title: 'Despacho en hojas de cálculo', description: 'Planificadores mandan PDFs y los conductores improvisan: nadie tiene la misma versión del día.' },
        { title: 'Caos de muelle y ventana', description: 'Ventanas perdidas en retail u obra generan penalizaciones y desconfianza.' },
        { title: 'Sin economía unitaria real', description: 'No enlazas combustible, tiempo y devoluciones a rentabilidad por cliente o corredor.' },
      ],
      features: [
        { title: 'Rutas según carga', description: 'Secuencia por peso, volumen y tipo de vehículo con caminos aptos para eje.', tag: 'IA' },
        { title: 'Ventanas concertadas', description: 'Reserva llegadas a tienda u obra con colchón y alertas de retraso.' },
        { title: 'POD enterprise', description: 'Firma, foto y confirmación por línea para disputas y auditorías.' },
        { title: 'Portales de cuenta', description: 'Grandes clientes ven estado y documentos sin llamar a despacho.' },
        { title: 'Analítica por corredor', description: 'Compara €/km, espera y puntualidad por ruta, hub y tier de cliente.' },
        { title: 'Flujos de excepción', description: 'Faltas de pago, rechazos y reentregas con responsable claro.' },
        { title: 'Conectores ERP y WMS', description: 'Pedidos y POD vuelven al sistema de registro.' },
        { title: 'Torre de control', description: 'Un mapa con camiones activos, riesgo de retraso y excepciones abiertas.' },
      ],
      useCases: [
        'Redistribución foodservice',
        'Distribuidores de bebidas',
        'Furgonetas de suministro industrial',
        'Papel y embalaje',
        'Salida de CD regional',
        'Última pierna cash & carry',
      ],
    },
    'medical-supplies': {
      name: 'Suministros médicos y laboratorios',
      tagline: 'Pensado para logística médica',
      headline: 'Logística de muestras, kits y suministro con',
      headlineHighlight: 'ventanas y trazabilidad',
      description:
        'Coordina recogidas y entregas para laboratorios, clínicas y suministro médico-quirúrgico con ventanas estrictas, trazabilidad tipo cadena de custodia y prueba auditable, alineado con flujo B2B sanitario.',
      heroKeyPoints: [
        'Programación crítica de recogida y entrega',
        'Listas de conductor para integridad de kit y temperatura cuando aplica',
        'Trazabilidad completa para auditores y socios',
        'Notificaciones al cliente con ETA en vivo',
      ],
      stats: [
        { value: '99,2%', label: 'Cumplimiento de ventana' },
        { value: '100%', label: 'Huella digital' },
        { value: '30%', label: 'Menos redespachos' },
      ],
      painPoints: [
        { title: 'SLA de recogida en laboratorio', description: 'Ventana de muestra perdida invalida la corrida: el teléfono no escala.' },
        { title: 'Auditoría y responsabilidad', description: 'Sin sellos de tiempo y firmas, las investigaciones son cruce de acusaciones.' },
        { title: 'Multisede', description: 'Hospitales, clínicas y depósitos con reglas y flujos de muelle distintos.' },
      ],
      features: [
        { title: 'Rutas con ventana', description: 'Restricciones duras y blandas por parada para agenda clínica y de laboratorio.', tag: 'IA' },
        { title: 'POD tipo cadena de custodia', description: 'Patrones de escaneo, sello, firma y foto defendibles en revisión.' },
        { title: 'Sensibilidad térmica', description: 'Marca y secuencia tramos sensibles con máximo tiempo en tránsito.' },
        { title: 'Alertas a interesados', description: 'Avisos a laboratorio y clínica en recogida, retraso y cierre de entrega.' },
        { title: 'Bucles recogida + entrega', description: 'Optimiza en un plan recogida de muestras y reparto de suministro.', tag: 'IA' },
        { title: 'Flujos de conductor', description: 'Pasos guiados para que nuevos conductores sigan el mismo camino conforme.' },
        { title: 'Analítica de cumplimiento', description: '% recogida a tiempo, motivos de excepción y espera por centro.' },
        { title: 'Integración LIS / EMR', description: 'Pedidos y estado desde stacks sanitarios y de laboratorio habituales.' },
      ],
      useCases: [
        'Mensajería de muestras diagnósticas',
        'Entrega de stock médico-quirúrgico',
        'Suministro a domicilio de salud',
        'Logística de kits de ensayo clínico',
        'Suministro dental e imagen',
        'Tramos de cadena de frío biotech',
      ],
    },
    'field-service': {
      name: 'Servicio de campo',
      tagline: 'Pensado para servicio de campo',
      headline: 'Citas, repuestos y camiones en',
      headlineHighlight: 'un solo despacho',
      description:
        'Tableros diarios para HVAC, instalaciones, telecom e industrial: habilidades, repuestos, SLA y ETAs de cliente alineados con tu CRM o FSM.',
      heroKeyPoints: [
        'Emparejamiento por habilidad y certificación',
        'Repuestos vinculados al vehículo para arreglar a la primera',
        'ETAs de cliente que se afinan con el día',
        'Foto y firma por orden de trabajo',
      ],
      stats: [
        { value: '18%', label: 'Más trabajos / técnico / día' },
        { value: '92%', label: 'Éxito primera visita' },
        { value: '40%', label: 'Menos «¿dónde está?»' },
      ],
      painPoints: [
        { title: 'Técnico equivocado en sitio', description: 'Olvidar certificación o herramienta obliga a un segundo desplazamiento.' },
        { title: 'Pieza no en la furgoneta', description: 'La orden está en agenda pero el inventario no se ligó a la ruta.' },
        { title: 'Ansiedad del cliente', description: 'Franjas estrechas sin ETA en vivo generan incomparecencias y quejas.' },
      ],
      features: [
        { title: 'Asignación por habilidades', description: 'Empareja OT con técnico por skill, zona y turno.', tag: 'IA' },
        { title: 'Vínculo de repuestos', description: 'Reserva o prepara piezas en ruta para no llegar con vehículo vacío.' },
        { title: 'ETAs dinámicas', description: 'Actualiza ETA a propietario o facility manager si el día se retrasa o adelanta.', tag: 'IA' },
        { title: 'Mapa en vivo de despacho', description: 'Todos los técnicos, estado de trabajo y riesgo de retraso en una pantalla.' },
        { title: 'POD de orden de trabajo', description: 'Fotos antes/después, firmas y notas en la parada.' },
        { title: 'Optimización de citas', description: 'Agrupa trabajos por geografía respetando la franja prometida.' },
        { title: 'Métricas de utilización', description: 'Horas facturables, ratio de desplazamiento y SLA por equipo.' },
        { title: 'Listo para CRM / FSM', description: 'Sincroniza trabajos, estado y cierre con tu stack.' },
      ],
      useCases: [
        'Instalación y mantenimiento HVAC',
        'Mantenimiento de edificios e instalaciones',
        'Técnicos de campo telecom',
        'Servicio de equipos industriales',
        'Instalaciones smart home y seguridad',
        'Control de plagas y servicios a propiedad',
      ],
    },
    'building-supplies': {
      name: 'Materiales de construcción y cargas voluminosas',
      tagline: 'Pensado para carga voluminosa',
      headline: 'Rutas pesadas y voluminosas con',
      headlineHighlight: 'ventanas y prueba',
      description:
        'Madera, puertas, sacos y repartos mixtos en obra con rutas según vehículo, ventanas de entrega y POD fotográfico que aguante disputas en obra.',
      heroKeyPoints: [
        'Rutas por clase de camión con tiempos de servicio realistas',
        'Contacto en obra y código de puerta en la parada',
        'Fotos de daños y colocación',
        'Agrupación de pedidos por geografía y reglas de grúa/carretilla',
      ],
      stats: [
        { value: '25%', label: 'Menos reentregas' },
        { value: '95%', label: 'Ventana cumplida' },
        { value: '20%', label: 'Menos combustible / tonelada' },
      ],
      painPoints: [
        { title: 'Vehículo incorrecto para la carga', description: 'Plataforma vs furgón equivocado implica entrega fallida y horas extra.' },
        { title: 'Acceso caótico en obra', description: 'El conductor llega sin código, contacto o instrucciones de descarga.' },
        { title: 'Disputas por daños', description: 'Sin fotos, las peleas «ya venía así» comen margen.' },
      ],
      features: [
        { title: 'Perfiles de vehículo', description: 'Ruta por capacidad, altura y tiempo de descarga por familia de SKU.', tag: 'IA' },
        { title: 'Ventanas de obra', description: 'Solo mañana o franjas con grúa, con colchón.' },
        { title: 'Instrucciones de obra', description: 'Contactos, códigos y riesgos visibles en la app del conductor.' },
        { title: 'POD de descarga', description: 'Serie de fotos y firma ligadas a línea y hora.' },
        { title: 'Rutas pesadas multistop', description: 'Secuencia de paradas voluminosas para menos recarga y retroceso.', tag: 'IA' },
        { title: 'Excepciones', description: 'Rechazo parcial, entrega parcial y reentrega con alerta a despacho.' },
        { title: 'Analítica tonelada-milla', description: 'Coste y tiempo por tonelada por sucursal y tipo de cliente.' },
        { title: 'Sincro pedidos ERP', description: 'Tira entregas abiertas y devuelve estado al hub de pedidos.' },
      ],
      useCases: [
        'Materiales y madereras',
        'Puertas y ventanas',
        'Cemento y áridos a saco',
        'Cubiertas y aislamiento',
        'Alquiler de herramientas con entrega',
        'Reparto pro desk a contratistas',
      ],
    },
    'automotive-parts': {
      name: 'Recambios de automoción',
      tagline: 'Pensado para repuestos',
      headline: 'Piezas urgentes y línea concesionario con',
      headlineHighlight: 'prioridad en ruta',
      description:
        'Soporta urgencias a concesionario, taller y retail con banderas de prioridad, cortes y seguimiento pensado para VOR y promesas de servicio.',
      heroKeyPoints: [
        'Prioridad VOR y urgente en el solver',
        'Compromisos horarios con taller y concesionario',
        'Verificación por escaneo en recogida y entrega',
        'Tablero para fuera de horario y sábados',
      ],
      stats: [
        { value: '45 min', label: 'Tramo urgente medio' },
        { value: '98%', label: 'Concesionario a tiempo' },
        { value: '15%', label: 'Menos km' },
      ],
      painPoints: [
        { title: 'Pánico VOR en despacho', description: 'Cada urgencia rompe el plan y el planificador rehace rutas a mano.' },
        { title: 'Pieza equivocada en muelle', description: 'El error sale en concesionario y se pierde credibilidad.' },
        { title: 'Deslizamiento del corte', description: '«Antes del mediodía» se diluye si la mañana es opaca.' },
      ],
      features: [
        { title: 'Niveles de prioridad', description: 'VOR, mismo día y estándar con peso en el optimizador.', tag: 'IA' },
        { title: 'Verificación por escaneo', description: 'Confirma SKU y ubicación en recogida; vuelve a escanear en recepción.' },
        { title: 'Optimización intraurbano', description: 'Bucles densos de concesionarios con menos vacío.', tag: 'IA' },
        { title: 'Comms con concesionario', description: 'SMS y correo con ETA en vivo y motivo de retraso.' },
        { title: 'Seguimiento de marca', description: 'Páginas OEM o distribuidor para cuentas premium.' },
        { title: 'POD de excepción', description: 'Documenta rechazos o entregas parciales con foto.' },
        { title: 'Cuadros de SLA', description: 'Puntualidad por tier de concesionario, familia de SKU y conductor.' },
        { title: 'Conectores DMS / IMS', description: 'Pedidos de piezas y acuses con tu cerebro de inventario.' },
      ],
      useCases: [
        'Programas nocturnos OEM',
        'Suministro a taller independiente',
        'Furgonetas de neumáticos al por mayor',
        'Accesorios mismo día',
        'Urgencias de carrocería',
        'Depósitos de flota',
      ],
    },
    'contract-logistics': {
      name: '3PL y logística por contrato',
      tagline: 'Pensado para 3PL',
      headline: 'Logística multicliente con',
      headlineHighlight: 'portales y SLA',
      description:
        'Transporte dedicado y compartido para varios expedidores con visibilidad segregada, ETAs tipo transportista y analítica en la que confían tus clientes, más allá de herramientas genéricas de mensajería.',
      heroKeyPoints: [
        'Seguimiento de marca y SLA por expedidor',
        'Planificación consciente de hub y línea troncal donde haga falta',
        'Reclamaciones y excepciones con auditoría',
        'Margen y coste de servicio por cuenta',
      ],
      stats: [
        { value: '30%', label: 'Menos trabajo de estado' },
        { value: '99%', label: 'Adopción del tracking' },
        { value: '2×', label: 'Onboarding más rápido' },
      ],
      painPoints: [
        { title: 'Saturación de visibilidad', description: 'Operaciones responde «¿dónde está?» decenas de veces al día.' },
        { title: 'SLA ambiguos', description: 'El contrato promete niveles que tu herramienta no mide ni prueba.' },
        { title: 'Puntos ciegos de margen', description: 'Ganas volumen pero pierdes en corredores que no modelaste por cliente.' },
      ],
      features: [
        { title: 'Visibilidad multicliente', description: 'Cada expedidor ve solo su carga, con su marca o la tuya.' },
        { title: 'Rutas de red', description: 'Optimiza hubs, línea troncal y última milla con vistas por rol.', tag: 'IA' },
        { title: 'Monitorización de SLA', description: 'Alertas antes de incumplir con acciones de recuperación sugeridas.' },
        { title: 'Eventos auditables', description: 'Estado, POD y comunicaciones con marca de tiempo por tramo.' },
        { title: 'Economía por cuenta', description: 'Ingresos, coste y margen por cliente y corredor.' },
        { title: 'Autoservicio del expedidor', description: 'Reserva, documentos y mapa en vivo sin correos en cadena.' },
        { title: 'Cuadros ejecutivos', description: 'Puntualidad, coste por pedido y calidad por contrato mayor.' },
        { title: 'API primero', description: 'Inyecta pedidos y empuja eventos a TMS, WMS y sistemas del expedidor.' },
      ],
      useCases: [
        'Transporte regional por contrato',
        '3PL de fulfillment e-commerce',
        'Flota dedicada industrial',
        'Tramos 3PL de cadena de frío',
        'Consolidación de entrada retail',
        'Última milla marca blanca',
      ],
    },
  },
};
